import { ProjectViewModel } from "../../ViewModel/ProjectViewModel";

export const getSpdrById = (spdrId: number, project: ProjectViewModel) => {
  return project.SpdrsOnThisProject?.find((spdr) => spdr.SpdrId === spdrId);
};
